module.exports = __webpack_public_path__ + "static/media/MY-CYBERJAYA.0d452680.png";